<div data-cy="iq-analysis-summary__page" class="py-30">
    <div class="flex align-center gap-15 px-30">
        <span class="star-badge animate-element"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
        <span class="sans-regular fc-black">{{'iq.analysis_labels.your_analysis_is_ready' | transloco}}</span>
    </div>
    <div class="gd-vertical gap-20 pl-71 pt-30 pr-30">
        <span>
            {{'iq.analysis_labels.i_have_examined_your_analysis' | transloco}}
            {{'iq.analysis_labels.a_number_of_suggestions_is_added' | transloco}}
        </span>
        <span>
            {{'iq.analysis_labels.not_sure' | transloco}}
            {{'iq.analysis_labels.read_why_dialogiq_thinks_each_item_is_relevant' | transloco}}
        </span>
    </div>


    <!-- Details of the summary -->
    <div class="bg-bugandy px-30 py-16 mt-40">
        <mat-progress-bar *ngIf="!loaded()" mode="indeterminate"></mat-progress-bar>
        <ng-container *ngIf="loaded()">
            <div class="gd-horizontal">
                <span class="clr-generic fs-14">{{'iq.analysis_labels.details' | transloco}}</span>
            </div>
            
            <div class="mt-35">
                <mat-accordion>
                    <app-generic-iq-analysis-summary-accordin #issuesAccordin [type]="'issues'" [itemsData]="allIssues"></app-generic-iq-analysis-summary-accordin>
                    <app-generic-iq-analysis-summary-accordin #stakeholdersAccordin [type]="'stakeholders'" [itemsData]="allStakeholders"></app-generic-iq-analysis-summary-accordin>
                    <app-generic-iq-analysis-summary-accordin #contextsAccordin [type]="'context_items'" [itemsData]="data" (itemDeclined)="onContextItemDeclined($event)"></app-generic-iq-analysis-summary-accordin>
                    <!-- <app-generic-iq-analysis-summary-accordin [type]="'Contact persons'"></app-generic-iq-analysis-summary-accordin> -->
                </mat-accordion>
            </div>
        </ng-container>
    </div>
</div>